import React from "react";
import TyCard from "./TyCard";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  title: {
    fontSize: 16,
    fontFamily: "lexend !important",
    color: "#28a382",
    fontWeight: 600,
    letterSpacing: "-0.4px",
    textAlign: "left",
  },
  subTxt: {
    fontFamily: "lexend !important",
    color: "#707070",
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: "-0.4px",
    textAlign: "left",
  },
  root: {
    display: "flex !important",
    alignItems: "flex-start !important",
    border: "2px solid #28a382",
    borderRadius: 20,
    padding: "1px 35px",
    width: 380,
  },
});

const ThankYouCard = ({ stepNumber, stepName, stepTxt }) => {
  const classes = useStyles();
  return (
    <div className="thankYouCard-root">
      <div className="step-number">
        <p style={{ margin: 0 }}>{stepNumber}</p>
      </div>

      <Card className={classes.root} variant="outlined">
        <CardContent>
          <Typography className={classes.title} color="stepName" gutterBottom>
            {stepName}
          </Typography>
          <Typography variant="h5" component="h2" className={classes.subTxt}>
            {stepTxt}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default ThankYouCard;
